export default defineNuxtPlugin(() => {
    if (!import.meta.client) {
        return;
    }

    const forms = document.querySelectorAll('.gravity-form');

    // Function to update page title with package info
    const updatePageTitle = (modal) => {
        const packageName = modal?.getAttribute('data-package-name');
        const packageVariation = modal?.getAttribute('data-package-variation');
        const packageSuburb = modal?.getAttribute('data-package-suburb');

        if (packageName && !modal.dataset.titleUpdated) {
            // Build the custom page title with package information
            const customTitle = `${packageName} - Marella Homes`;

            // Store original title in modal
            if (!modal.dataset.originalTitle) {
                modal.dataset.originalTitle = document.title;
            }

            // Change the page title so HubSpot captures it
            document.title = customTitle;
            modal.dataset.titleUpdated = 'true';

            // Update HubSpot page context
            if (typeof window._hsq !== 'undefined') {
                window._hsq.push(['setPath', window.location.pathname + '?package=' + encodeURIComponent(packageName)]);
                window._hsq.push(['trackPageView', customTitle]);
            }
        }
    };

    // Update title when modal opens
    document.querySelectorAll('.modal').forEach(modal => {
        modal.addEventListener('shown.bs.modal', function() {
            updatePageTitle(this);
        });

        modal.addEventListener('hidden.bs.modal', function() {
            // Restore original title when modal closes
            if (this.dataset.originalTitle) {
                document.title = this.dataset.originalTitle;
                delete this.dataset.titleUpdated;
                delete this.dataset.originalTitle;
            }
        });
    });

    forms.forEach(form => {
        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const btn = form.querySelector('[type="submit"]');
            const div = form.querySelector('#submit-message');

            btn.setAttribute('disabled', 'disabled');

            const modal = form.closest('.modal');
            updatePageTitle(modal);
            await new Promise(resolve => setTimeout(resolve, 500));

            const response = await fetch(form?.action, {body: new FormData(form), method: 'POST'});
            const json = await response?.json();

            if (response?.ok && alert) {
                const message = json?.confirmation_message || '';

                div.innerHTML = message.toString();
                div.classList.add('text-success');
                div.classList.remove('text-danger');
                div.classList.remove('d-none');
            } else {
                const validations = [];
                const messages = json?.validation_messages || {};

                Object.keys(messages).forEach((k) => validations.push(messages[k]));
                div.innerHTML = validations.join('<br/>');
                div.classList.add('text-danger');
                div.classList.remove('text-success');
                div.classList.remove('d-none');
            }

            setTimeout(() => {
                div.classList.add('d-none');
            }, 5000)

            btn.removeAttribute('disabled');
        });
    });

    document.querySelectorAll('input[type="radio"]').forEach(radio => {
        radio.addEventListener('click', function() {
            if (this.dataset.checked === 'true') {
                this.checked = false;
                this.dataset.checked = 'false';
            } else {
                // Uncheck others in the same group
                document.querySelectorAll(`input[name="${this.name}"]`).forEach(r => {
                    r.dataset.checked = 'false';
                });
                this.dataset.checked = 'true';
            }
        });
    });
});
